module.exports = __webpack_public_path__ + "static/img/021_5.63752f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_5.jpg
// module id = hbu8
// module chunks = 1